// Shared Chemistry Diagram Component
// Used in FactSheetSection_V2.jsx and ChemicalSection_NEW.jsx
// Shows bidirectional ion flow between anode and cathode

export default function ChemistryDiagram({ anode, cathode, ionLabel }) {
  return (
    <div className="chemistry-diagram-compact">
      <div className="electrode-with-label anode-group">
        <div className="electrode anode">
          <svg width="40" height="60" viewBox="0 0 24 24" fill="none" stroke="#0d7c99" strokeWidth="3">
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </div>
        <span className="electrode-label">{anode || 'Anode'}</span>
      </div>
      <div className="ion-flow">
        <svg width="180" height="60" viewBox="0 0 180 60" preserveAspectRatio="xMidYMid meet">
          {/* Arrow right (discharge) - centered vertically */}
          <path d="M10 30 L160 30" stroke="url(#ionGradRight)" strokeWidth="4" strokeDasharray="5 5"/>
          <polygon points="170,30 160,25 160,35" fill="#ea5b0c"/>
          
          {/* Arrow left (charge) - centered vertically */}
          <path d="M170 30 L20 30" stroke="url(#ionGradLeft)" strokeWidth="4" strokeDasharray="5 5"/>
          <polygon points="10,30 20,25 20,35" fill="#0d7c99"/>
          
          <defs>
            <linearGradient id="ionGradRight">
              <stop offset="0%" stopColor="#0d7c99"/>
              <stop offset="100%" stopColor="#ea5b0c"/>
            </linearGradient>
            <linearGradient id="ionGradLeft">
              <stop offset="0%" stopColor="#ea5b0c"/>
              <stop offset="100%" stopColor="#0d7c99"/>
            </linearGradient>
          </defs>
        </svg>
        <span className="li-ion-label">{ionLabel || 'Li⁺'}</span>
      </div>
      <div className="electrode-with-label cathode-group">
        <div className="electrode cathode">
          <svg width="40" height="60" viewBox="0 0 24 24" fill="none" stroke="#ea5b0c" strokeWidth="3">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </div>
        <span className="electrode-label">{cathode || 'Cathode'}</span>
      </div>
    </div>
  )
}
